import { render, staticRenderFns } from "./chemMsdsFile.vue?vue&type=template&id=683c1a1e"
import script from "./chemMsdsFile.vue?vue&type=script&lang=js"
export * from "./chemMsdsFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683c1a1e')) {
      api.createRecord('683c1a1e', component.options)
    } else {
      api.reload('683c1a1e', component.options)
    }
    module.hot.accept("./chemMsdsFile.vue?vue&type=template&id=683c1a1e", function () {
      api.rerender('683c1a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemMsdsFile.vue"
export default component.exports